import Tr from 'translations/Translations';

const _TR_PREFIX = 'offer_encryption_status_';

export const OfferEncryptionStatuses = {
    DECRYPTED: 'decrypted',
    ENCRYPTED: 'encrypted',
    PENDING: 'pending'
}

export const OfferEncryptionStatusLabel = (status) => Tr(_TR_PREFIX + status);